<template>
  <b-container fluid v-if="loaded">
    <toolbar :order="mergedOrder" />
    <rma-refund-banner :order="mergedOrder" />
    <b-alert show v-if="isDistributor" variant=danger>
      This is an International Distributor, please check with International Distribution Manager
    </b-alert>
    <b-modal v-if="isDistributor" visible ok-only centered scrollable size="lg" title="International Distributor Warning">
      <strong>This is an International Distributor, please check with International Distribution Manager</strong>
    </b-modal>
    <b-row class="mb-2">
      <b-col>
        <basic-info
          :order="mergedOrder"
          :fishbowl-order="fishbowlOrder"
          :website-order="websiteOrder"
          :is-web-return="isWebReturn"
        />
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col cols="12" md="6" lg="3">
        <div class="d-flex flex-column pb-2" style="height: 100%;">
          <div class='flex-fill'>
            <billing-address :order="mergedOrder" />
          </div>
          <div>
            <fishbowl-payments :order="mergedOrder" />
          </div>
        </div>
      </b-col>
      <b-col cols=12 md=6 lg=3>
        <shipping-address :order="mergedOrder" :returnLabelCents="returnLabelCents" />
      </b-col>
      <b-col lg=6>
        <order-notes :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row v-if=isWebReturn>
      <b-col>
        <return-info :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <order-items :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <pick-ticket :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <a-m-cash :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <gift-cards :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <external-products :order=mergedOrder />
      </b-col>
    </b-row>
    <b-row v-if="!isWebReturn">
      <b-col>
        <pack-ship :order=fishbowlOrder />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios'
import Toolbar from './Toolbar.vue'
import RmaRefundBanner from './RmaRefundBanner.vue'
import BasicInfo from './BasicInfo.vue'
import AddressInfo from './AddressInfo.vue'
import BillingAddress from './BillingAddress.vue'
import ShippingAddress from './ShippingAddress.vue'
import DataMerger from '../../utility/DataMerger.vue'
import FishbowlPayments from './FishbowlPayments.vue'
import OrderNotes from './OrderNotes.vue'
import ReturnInfo from './ReturnInfo.vue'
import OrderItems from './OrderItems.vue'
import PickTicket from './PickTicket.vue'
import AMCash from './AMCash.vue'
import GiftCards from './GiftCards.vue'
import ExternalProducts from './ExternalProducts.vue'
import PackShip from './PackShip.vue'
import orderMerge from '../../../services/orderMerge'
const BASE_API = process.env.VUE_API_ROOT

export default {
  data() {
    return {
      mergedOrder: {},
      websiteOrder: {},
      fishbowlOrder: {},
      loaded: false,
    }
  },
  components: {
    DataMerger,
    Toolbar,
    RmaRefundBanner,
    BasicInfo,
    AddressInfo,
    BillingAddress,
    ShippingAddress,
    FishbowlPayments,
    OrderNotes,
    ReturnInfo,
    OrderItems,
    PickTicket,
    AMCash,
    GiftCards,
    ExternalProducts,
    PackShip,
  },
  mounted() {
    axios.get(`${BASE_API}/bridge/${this.$route.params.id}`).then(response => {
      this.mergedOrder = response.data.merged;
      this.websiteOrder = response.data.web;
      this.fishbowlOrder = response.data.fishbowl;
    }).finally(() => this.loaded = true);
  },
  computed: {
    isWebReturn() {
      return false //!!this.mergedOrder && !!this.mergedOrder.num && this.mergedOrder.num.toUpperCase().startsWith("R") && !!this.mergedOrder.websiteName && this.websiteOrder.status !== 'doesnt_exist'
    },
    returnLabelCents() {
      return this.websiteOrder ? (this.websiteOrder.providedShippingLabel ? this.websiteOrder.shippingLabelPrice * 100 : undefined) : null
    },
    isDistributor() {
      if (!this.websiteOrder || !this.websiteOrder.customerPrivateNotes) {
        return false
      } 
      
      return [this.websiteOrder.customerPrivateNotes].flat().some(n => {
        return n.includes("Questions see Int'l Distribution Manager")
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/ViewOrder.vue